export default __webpack_public_path__ + "static/media/arrow-right-circle-fill.f75a5089.svg";